export default __webpack_public_path__ + "static/media/logo-eg.61179f98.svg";